import { fetchNotifications, updateNotifications } from './api/notifications';
import { FETCH_PARAMS, ITEM_STATES } from './utils';

export default {
    idle() {},
    async fetching(event) {
        const { type } = event;

        try {
            const params = { ...FETCH_PARAMS, ...this.fetchParams, ...(event.params || {}) };
            const { results = [], count, next } = await fetchNotifications(params);
            const { page = 1 } = params;

            this.pagination = { count, next, page };
            this.notifications = [...(type === 'REFETCH' ? [] : this.notifications), ...results];

            this.$transition({ type: 'SUCCESS' });
        } catch (error) {
            this.$transition({ type: 'FAILED', error });
        } finally {
            this.loading = false;
        }
    },
    async updating({ state, item = {}, filter = () => true }) {
        this.loading = true;

        try {
            const { id = null } = item;
            const notifications = id ? [id] : this.notifications.filter(filter).map(({ id }) => id);

            await updateNotifications({ notifications, state });
            this.$transition({ type: 'SUCCESS', item });
        } catch (error) {
            this.$transition({ type: 'FAILED', error });
        } finally {
            this.loading = false;
        }
    },
    redirecting({ item }) {
        const { url: path = null } = item;
        const { finite: state } = ITEM_STATES;

        if (!path) {
            return this.$transition({ type: 'FAILED', error: 'Invalid URL' });
        }

        this.loading = true;
        this.$router.push({ path });
        this.$transition({ type: 'UPDATE', state, item });
    },
    failed({ error }) {
        console.log('FAILED', error);
    },
    reset() {
        this.notification = [];
        this.$transition({ type: 'DONE' });
    },
};
